import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import AppButton from '../../../../components/app-button';
import RegisterHeader from '../../../../components/headers/register-header';
import Header1 from '../../../../components/headers/header1';
import Header2 from '../../../../components/headers/header2';
import { Column, Row } from '../../../../components/layout';
import colors from '../../../../util/colors';
import * as fonts from '../../../../util/fonts';
import { strings } from '../../../../util/strings';
import { censorEmail } from '../../../../util/utility';
import { addToWizard } from '../../../../store/actions';
import './styles.scss';

interface AssociateEmailProps {
  wizard: any;
  globalStyles: any;
  labels?: typeof strings.pt.register;
  addToWizard?: (value: any) => void;
}

function AssociateEmail({ wizard, globalStyles, labels, addToWizard }: AssociateEmailProps) {
  const history = useHistory();
  const primaryColor = globalStyles?.primaryColor || colors.blue;

  const rawEmail =
    wizard?.dataValidation?.currentUser?.email ||
    wizard?.dataValidation?.selectedContact ||
    '';

  const displayedEmail = rawEmail.includes('*') ? rawEmail : censorEmail(rawEmail);

  const handleUseThisEmail = () => {
    if (addToWizard) {
      addToWizard({
        dataValidation: {
          ...wizard?.dataValidation,
          selectedContact: rawEmail,
          selectedContactType: 'EMAIL',
          useSessionEmail: true,
          useSessionPhone: false,
          isNewEmail: false,
        },
      });
    }
    history.push('/registo/definir-palavra-passe');
  };

  const handleUseOtherEmail = () => {
    if (addToWizard) {
      addToWizard({
        dataValidation: {
          ...wizard?.dataValidation,
          useSessionEmail: false,
          isNewEmail: true,
        },
      });
    }
    history.push('/registo/novo-email');
  };

  return (
    <Column className="register-main-column">
      <RegisterHeader />
      <Column className="register-container" style={{ alignItems: 'center' }}>
        <Row className="register-header-row" style={{ justifyContent: 'center', marginTop: '2.5rem' }}>
          <Header1 style={{ ...fonts.XL, ...fonts.Bold, color: colors.black, textAlign: 'center' }}>
            {labels?.register_select_email_username_title}
          </Header1>
        </Row>

        <Column
          className="register-existing-user-text"
          style={{
            ...fonts.ML,
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '380px',
            width: '100%',
          }}
        >
          <Header2
            style={{
              ...fonts.M,
              marginBottom: '2.5rem',
              textAlign: 'center',
              color: colors.darkGrey,
              lineHeight: '1.4',
            }}
          >
            {labels?.register_select_email_username_description}
          </Header2>

          <Row
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '3rem',
              width: '100%',
            }}
          >
            <svg
              width="28"
              height="22"
              viewBox="0 0 24 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: '12px', flexShrink: 0 }}
            >
              <rect
                x="1"
                y="1"
                width="22"
                height="18"
                rx="3"
                stroke={primaryColor}
                strokeWidth="2"
              />
              <path
                d="M2 3L12 11L22 3"
                stroke={primaryColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span style={{ ...fonts.M, ...fonts.Bold }}>
              {displayedEmail}
            </span>
          </Row>

          <AppButton
            onClick={handleUseThisEmail}
            style={{
              ...fonts.M,
              ...fonts.Bold,
              width: '100%',
              maxWidth: '350px',
              borderRadius: '25px',
              height: '50px',
              backgroundColor: primaryColor,
              color: colors.white,
              marginBottom: '1.25rem',
              cursor: 'pointer',
            }}
          >
            {labels?.register_select_email_username_button_yes}
          </AppButton>

          <AppButton
            onClick={handleUseOtherEmail}
            style={{
              ...fonts.M,
              ...fonts.Bold,
              width: '100%',
              maxWidth: '350px',
              borderRadius: '25px',
              height: '50px',
              backgroundColor: colors.white,
              border: `1px solid ${primaryColor}`,
              color: primaryColor,
              cursor: 'pointer',
            }}
          >
            {labels?.register_select_email_username_button_no}
          </AppButton>
        </Column>
      </Column>
    </Column>
  );
}

const mapStateToProps = ({ stringsDefault, wizard, globalStyles }: any) => ({
  labels: stringsDefault?.value?.pt?.register,
  wizard: wizard.value,
  globalStyles: globalStyles.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(AssociateEmail);
